/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = function _default(className) {
  return function (element, modifier) {
    var el = element ? "-".concat(element) : '';
    var mod = modifier ? "--".concat(modifier) : '';
    return "".concat(className).concat(el).concat(mod);
  };
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/bemFactory.js
// module id = 577
// module chunks = 0